export default {"src":"/_next/static/media/trees.a931d266.svg","height":96,"width":96};